const React = require('react');
const css = require('./module.scss');
const Prompt = require('../dialog/prompt.js');
const WebUploader = require('WebUploader');

const noop = () => {};

const dictSizeLvl = [
    '', ...['K', 'M', 'G'].map(e => `${e}`)
].map(e => `${e}`);

const b2read = ({
    precision
} = {}) => {
    return param => {
        let lvl = 0;
        let res = param;
        while (res >= 1024) {
            res /= 1024;
            lvl++;
        }
        const prec = parseFloat(precision);
        if (!isNaN(prec)) {
            res = Math.round(res / prec) * prec;
        }
        return `${res} ${dictSizeLvl[lvl]}`;
    };
};
const b2readRaw = b2read();

const errValDir = {
    F_EXCEED_SIZE: (up) => {
        let fl = up.options.fileSingleSizeLimit;
        return `添加的文件大小不能超过${b2readRaw(fl)}`;
    },
    F_DUPLICATE: (up) => {
        return `添加的文件重复了`;
    },
    Q_EXCEED_NUM_LIMIT: (up) => {
        console.error(up.options);
        return `添加的文件数量不能超过限制`;
    },
    Q_EXCEED_SIZE_LIMIT: (up) => {
        console.error(up.options);
        return `添加的文件总大小不能超过限制`;
    },
    Q_TYPE_DENIED: (up) => {
        let extStr = '';
        try {
            extStr = `，后缀名参考列表：${up.options.accept[0].extensions}`;
        }
        catch (e) {
            console.log(e);
        }
        return `添加的文件文件类型不满足${extStr}`;
    }
};

const errUplValDir = {
    http: (file, up) => {
        return `网络错误，请联系管理员或稍后重试`;
    },
    server: (file, up) => {
        return `服务端错误，请联系管理员或稍后重试`;
    },
    timeout: (file, up) => {
        return `请求超时，请联系管理员或稍后重试`;
    }
};


var UploaderImage = React.createClass({
    getInitialState: function () {
        return {
            imageAccept: {
                title: 'Images',
                extensions: 'gif,jpg,jpeg,bmp,png',
                mimeTypes: 'image/*'
            },
            uploader: {}
        };
    },
    loadStyle: function (url) {
        var link = document.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.href = url;
        document.getElementsByTagName('head')[0].appendChild(link);
    },
    componentDidMount: function () {
        this.initUploader();
    },
    removeFile: function (id) {
        this.uploader.removeFile(id);
    },
    initUploader: function () {
        var me = this;
        var loading;
        var accept = this.props.accept === undefined ?
            this.state.imageAccept :
            this.props.accept;
        this.uploader = WebUploader.create({
            // 选完文件后，是否自动上传。
            auto: (me.props.auto === false || me.props.auto === "false") ?
                false :
                true,
            // swf文件路径
            swf: '../../lib/webuploader/Uploader.swf',
            // 文件接收服务端。
            server: me.props.server,
            fileVal: this.props.fileVal || 'file',
            // 选择文件的按钮。可选。
            // 内部根据当前运行是创建，可能是input元素，也可能是flash.
            pick: {
                id: '#' + me.props.pick,
                multiple: me.props.multiple ? true : false // 允许多文件上传
            },
            // 允许文件类型。
            accept: accept,
            // 可重复上传
            duplicate: me.props.duplicate || true,
            // 一次上传文件数量
            fileNumLimit: this.props.fileNumLimit || undefined,

            // 单个文件大小
            fileSingleSizeLimit: me.props.fileSingleSizeLimit || 10 * 1024 * 1024,
        });

        let uploader = this.uploader;
        uploader.on('uploadSuccess', function (file, src) {
            if (src && src.code == '0003') {
                Prompt.error('未登录，正在跳转去登录！');
                setTimeout(() => {
                    window.location.href = '/vlfront/sign/signIn?toUrl=' + encodeURIComponent(location.href);
                }, 1000);
                return;
            } else if (src && src.code !== '0000') {
                Prompt.error('上传失败！' + (src.codeMsg || ''));
                me.props.onSuccess && me.props.onSuccess(file, src);
                return;
            }
            me.props.onSuccess && me.props.onSuccess(file, src);
        });

        const comErrHandle = errMsg => Prompt.warn(`${errMsg}`);

        uploader.on('error', function (type) {
            me.props.onError && me.props.onError(type);
            const errTans = errValDir[type] || (() => `发生错误，请联系管理员(type:${type})`);
            const errMsg = errTans(this);
            comErrHandle(errMsg);
            return false;
        });

        uploader.on('uploadError', function (file, reason) {
            me.props.onUploadError && me.props.onUploadError(file, reason);
            if (reason == 'abort') {
                Prompt.warn('用户取消');
            } else {
                const errTans = errUplValDir[reason] || (() => `发生错误，请联系管理员(reason:${reason})`);
                const errMsg = errTans(file, this);
                comErrHandle(errMsg);
            }
        });

        // 当开始上传流程时触发。
        uploader.on('startUpload', function () {
            loading = Prompt.loading('正在上传文件...');
            me.props.startUpload && me.props.startUpload();
        });

        const loadingDestroy = () => {
            if (loading) {
                loading && loading.destroy();
                loading = null;
            }
        };
        // 不管成功或者失败，文件上传完成时触发。
        uploader.on('uploadComplete', function (arg) {
            loadingDestroy();
            me.props.uploadComplete && me.props.uploadComplete();
        });

        // 当所有文件上传结束时触发
        uploader.on('uploadFinished', function (arg) {
            loadingDestroy();
            me.props.uploadFinished && me.props.uploadFinished();
        });

        // 某个文件开始上传前触发，一个文件只会触发一次
        uploader.on('uploadStart', function (file) {
            me.props.uploadStart && me.props.uploadStart(file);
        });

        // 当文件被加入队列之前触发，此事件的handler返回值为false，则此文件不会被添加进入队列。
        uploader.on('beforeFileQueued', function (file) {
            if (me.props.beforeFileQueued) {
                if(me.props.formData){
                    uploader.options.formData =me.props.formData;
                }
                return me.props.beforeFileQueued(file);
            }
        });

        // 当文件被加入队列以后触发。
        uploader.on('fileQueued', function (file) {
            me.setState({
                lastFile: file
            });
            me.props.fileQueued && me.props.fileQueued(file);
        });

        // 上层组件需要直接控制uploader时。
        me.props.onUploaderReady && me.props.onUploaderReady(uploader);

    },
    render: function () {
        let cls = ['fp-uploader-btn'];
        if (this.props.className) {
            cls.push(this.props.className);
        }
        if (this.props.style) {
            cls.push('fp-uploader-btn-' + this.props.style);
        }
        return <div id = {this.props.pick} className = {cls.join(' ')}>
            {this.props.label}
        </div>;
    }
});
module.exports = UploaderImage;



// WEBPACK FOOTER //
// ./component/uploader/uploader.js